
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M18.7001 12.4C18.42 12.24 18.13 12.11 17.84 12C18.13 11.89 18.42 11.76 18.7001 11.6C20.6201 10.49 21.6901 8.48 21.7001 6.41C19.91 5.38 17.63 5.3 15.7 6.41C15.42 6.57 15.16 6.76 14.92 6.95C14.97 6.64 15 6.32 15 6C15 3.78 13.79 1.85 12 0.809998C10.21 1.85 9.00005 3.78 9.00005 6C9.00005 6.32 9.03005 6.64 9.08005 6.95C8.84005 6.75 8.58005 6.56 8.30005 6.4C6.38005 5.29 4.10005 5.37 2.30005 6.4C2.30005 8.47 3.37005 10.48 5.30005 11.59C5.58005 11.75 5.87005 11.88 6.16005 11.99C5.87005 12.1 5.58005 12.23 5.30005 12.39C3.38005 13.5 2.31005 15.51 2.30005 17.58C4.09005 18.61 6.37005 18.69 8.30005 17.58C8.58005 17.42 8.84005 17.23 9.08005 17.04C9.03005 17.36 9.00005 17.68 9.00005 18C9.00005 20.22 10.21 22.15 12 23.19C13.79 22.15 15 20.22 15 18C15 17.68 14.97 17.36 14.92 17.05C15.16 17.25 15.42 17.43 15.7 17.59C17.62 18.7 19.9001 18.62 21.7001 17.59C21.6901 15.52 20.6201 13.51 18.7001 12.4ZM12 16C9.79005 16 8.00005 14.21 8.00005 12C8.00005 9.79 9.79005 8 12 8C14.21 8 16 9.79 16 12C16 14.21 14.21 16 12 16Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-filter-vintage`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconFilterVintage

    ```js
    <b-new-b-icon-filter-vintage />
    ```
</docs>


